import { Capacitor } from "@capacitor/core";

/**
 * True when the app is running inside the Capacitor native shell
 * (the installed Android / iOS Companion app), false in a normal browser
 * tab or installed PWA. Used to boot straight into the Companion,
 * skip the beta site-gate, and lock the shell to companion-only.
 */
export function isNativeApp() {
  try {
    return !!(Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform());
  } catch (_) {
    return false;
  }
}

/**
 * Open a URL in the device's SYSTEM browser instead of the native WebView.
 *
 * Capacitor's default `onCreateWindow` handler routes `window.open(..., "_blank")`
 * to an external ACTION_VIEW intent, so this needs NO extra native plugin and
 * therefore NO .aab rebuild. `path` may be an absolute URL or a same-origin path.
 */
export function openExternal(path) {
  const origin =
    (typeof window !== "undefined" && window.location.origin) || "https://glpflo.org";
  const url = path && /^https?:\/\//.test(path) ? path : `${origin}${path || ""}`;
  try {
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (_) {
    if (typeof window !== "undefined") window.location.href = url;
  }
}
